export default __webpack_public_path__ + "static/assets/51f62929788625f14a129c520af3d14f.png";